// core
import {Injectable} from '@angular/core';

// constants
import {AppConstants} from '../../utils/constants';

//components
import {ErrorModal} from '../../shared/dialogs/error-modal/error-modal.component';
import {ConfirmationModal} from '../../shared/dialogs/confirmation-modal/confirmation-modal.component';

// service
import {TranslateService} from "@ngx-translate/core";

// ng-bootstrap UI
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

declare const $: any;

@Injectable()
export class ErrorMessageService {
  constructor(
  private _modalService: BsModalService,
  private _translateService: TranslateService,
  ) {
  }

  // Modals
  public errorModalRef: BsModalRef;
  public confirmationModalRef: BsModalRef;

  public showSuccessToastr(msg) {
    const content = ErrorMessageService.createToastr(msg, AppConstants.alertSuccess);
    $("#toastrContainer").append(content);
    content.delay(2500).fadeOut(400, () => {
      content.remove();
    });
  }

  public showErrorToastr(msg) {
    const content = ErrorMessageService.createToastr(msg, AppConstants.alertDanger);
    $("#toastrContainer").append(content);
    content.delay(10000).fadeOut(400, () => {
      content.remove();
    });
  }

  public showWarningToastr(msg) {
    const content = ErrorMessageService.createToastr(msg, AppConstants.alertWarning);
    $("#toastrContainer").append(content);
    content.delay(10000).fadeOut(400, () => {
      content.remove();
    });
  }

  private static createToastr(msg, type) {
    return $(`<div role='alert' class='w-100 alert ${type}'>${msg}</div>`);
  }

  /**
   * Display message for the user in error-dialog
   * @param msg Error message for the user
   * @public
   */
  public openErrorModal(msg) {
    this.errorModalRef = this._modalService.show(ErrorModal);

    let messageToTranslate = '';
    if (msg && typeof msg === 'object' && msg.message) {
      messageToTranslate = msg.message;
    } else if (typeof msg === 'string') {
      messageToTranslate = msg;
    }

    if (messageToTranslate === null || messageToTranslate === '') {
      this._translateService.get('There has been an error, please contact the Solarlux team!').subscribe((res: string) => {
        this.errorModalRef.content.errorMessage = res;
      });
    } else {
      this._translateService.get(messageToTranslate).subscribe((res: string) => {
        this.errorModalRef.content.errorMessage = res;
      });
    }
  }

  /**
     * Display message for the user in confirmation-dialog
     * @param msg Confirmation message for the user
     * @public
     */
  public openConfirmationModal(msg) {
      this.confirmationModalRef = this._modalService.show(ConfirmationModal);
      this._translateService.get(msg).subscribe((res: string) => {
        this.confirmationModalRef.content.confirmationMessage = res;
      });
  }

}
